<template>
  <div>
    <CRow>
      <CCol col="12" lg="12">
        <CCard>
          <CCardHeader id="page-dev-header">
            <h5>{{tmpSectionBuilder.name}}</h5>
          </CCardHeader>
          <CCardBody id="page-dev-tool">
            <PageDevTool
              style="height: 100vh;"
              v-if="tmpSectionBuilder.id"
              :value="tmpSectionBuilder"
              @input="onPageDevToolContentChange"
              :display-preview="displayPreview"
              :display-editable-box="!displayPreview"
            />
          </CCardBody>
          <CCardFooter>
            <LoadingStateButton 
              @click="displayPreview = !displayPreview"
              :text="displayPreview ? i18nMessage.Edit : i18nMessage.Preview"
              color="dark"
            />
            &nbsp;
            <LoadingStateButton
              v-if="displayPreview"
              @click="() => onAddOrUpdateDraftSectionBuilder(false)"
              :text="i18nMessage.SaveDraft"
              color="primary"
              :loading="updateSectionBuilderLoading"
            />
            &nbsp;
            <LoadingStateButton
              v-if="displayPreview"
              @click="() => onAddOrUpdateDraftSectionBuilder(true)"
              :text="i18nMessage.Deploy"
              color="success"
              :loading="updateSectionBuilderLoading"
            />
            &nbsp;
            <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID, isEmpty } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'
import HtmlEditor from '../../components/HtmlEditor'
import PageDevTool from '../../components/PageDevTool'


export default {
  name: 'SectionBuilderEditor',
  components: {
    AppForm,
    LoadingStateButton,
    HtmlEditor,
    PageDevTool,
  },
  data () {
    return {
      tmpSectionBuilder: {},
      updateSectionBuilderLoading: false,
      appFormKey: generateGUID(),
      displayPreview: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      sectionBuilder: state => state.pageBuilder.sectionBuilder,
      defaultGlobalStyles: state => state.defaultGlobalStyles,
    }),
  },
  methods: {
    ...mapActions({
      getDraftSectionBuilder: 'pageBuilder/getDraftSectionBuilder',
      addDraftSectionBuilder: 'pageBuilder/addDraftSectionBuilder',
      updateDraftSectionBuilder: 'pageBuilder/updateDraftSectionBuilder',
      deployDraftSectionBuilder: 'pageBuilder/deployDraftSectionBuilder',
      discardDraftSectionBuilder: 'pageBuilder/discardDraftSectionBuilder',
    }),
    ...mapMutations({
      setSectionBuilder: 'pageBuilder/setSectionBuilder',
    }),
    goBack() {
      this.$router.push({path: '/section-builder-editor'})
    },
    onEditorContentChange (template, style) {
      this.tmpSectionBuilder = {
        ...this.tmpSectionBuilder,
        template,
        style,
      }
    },
    onPageDevToolContentChange (data) {
      this.tmpSectionBuilder = {...data}
    },
    onFormChange (data) {
      this.tmpSectionBuilder = {...data}
    },
    onAddOrUpdateDraftSectionBuilder (isDeploy) {
      if (isEmpty(this.tmpSectionBuilder)) {
        return
      }
      if (this.tmpSectionBuilder.id) {
        this.updateSectionBuilderLoading = true
        this.updateDraftSectionBuilder({
          input: this.tmpSectionBuilder,
          isDeploy: isDeploy,
        })
          .then(() => {
            this.updateSectionBuilderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateSectionBuilderLoading = false
          })
      } else {
        this.updateSectionBuilderLoading = true
        this.addDraftSectionBuilder({
          input: this.tmpSectionBuilder,
          isDeploy: isDeploy,
        })
          .then(() => {
            this.updateSectionBuilderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateSectionBuilderLoading = false
          })
      }
    },
  },
  mounted() {
    this.getDraftSectionBuilder(this.$route.params.id).then(() => {
      this.tmpSectionBuilder = this.sectionBuilder
    })
  },
  destroyed() {
    this.setSectionBuilder({})
  },
  watch: {},
}
</script>

<style scoped>
  #page-dev-tool {
    padding: 0px;
  }

  #page-dev-header {
    padding: 0.3rem;
    padding-top: 0.6rem;
  }
</style>